/**
 * @flow
 * @relayHash 7259addf2091af02142ce82deecc29f4
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CategoriesApp_viewer$ref = any;
export type queries_CategoriesQueryVariables = {|
  section: string
|};
export type queries_CategoriesQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: CategoriesApp_viewer$ref
  |}
|};
export type queries_CategoriesQuery = {|
  variables: queries_CategoriesQueryVariables,
  response: queries_CategoriesQueryResponse,
|};
*/


/*
query queries_CategoriesQuery(
  $section: ID!
) {
  viewer {
    ...CategoriesApp_viewer_1hrbBR
    id
  }
}

fragment CategoriesApp_viewer_1hrbBR on Viewer {
  ...CategoriesEditor_viewer_1hrbBR
}

fragment CategoriesEditor_viewer_1hrbBR on Viewer {
  id
  categories(first: -1, section: $section) {
    edges {
      node {
        id
        name
        hidden
        slug
        section
        seoTitle
        seoKeywords
        seoDescription
      }
    }
  }
  sections {
    edges {
      node {
        id
        name
        hidden
      }
    }
  }
  section(id: $section) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "section",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hidden",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "queries_CategoriesQuery",
  "id": null,
  "text": "query queries_CategoriesQuery(\n  $section: ID!\n) {\n  viewer {\n    ...CategoriesApp_viewer_1hrbBR\n    id\n  }\n}\n\nfragment CategoriesApp_viewer_1hrbBR on Viewer {\n  ...CategoriesEditor_viewer_1hrbBR\n}\n\nfragment CategoriesEditor_viewer_1hrbBR on Viewer {\n  id\n  categories(first: -1, section: $section) {\n    edges {\n      node {\n        id\n        name\n        hidden\n        slug\n        section\n        seoTitle\n        seoKeywords\n        seoDescription\n      }\n    }\n  }\n  sections {\n    edges {\n      node {\n        id\n        name\n        hidden\n      }\n    }\n  }\n  section(id: $section) {\n    id\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "queries_CategoriesQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CategoriesApp_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "section",
                "variableName": "section",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "queries_CategoriesQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          v1,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "categories",
            "storageKey": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": -1,
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "section",
                "variableName": "section",
                "type": "ID!"
              }
            ],
            "concreteType": "CategoryConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CategoryEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Category",
                    "plural": false,
                    "selections": [
                      v1,
                      v2,
                      v3,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "slug",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "section",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "seoTitle",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "seoKeywords",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "seoDescription",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "sections",
            "storageKey": null,
            "args": null,
            "concreteType": "SectionConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "SectionEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Section",
                    "plural": false,
                    "selections": [
                      v1,
                      v2,
                      v3
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "section",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "section",
                "type": "ID!"
              }
            ],
            "concreteType": "Section",
            "plural": false,
            "selections": [
              v1
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5b741278c7ee0094d95e89bd5b8a2274';
module.exports = node;



// WEBPACK FOOTER //
// src/__generated__/queries_CategoriesQuery.graphql.js